// Public reading has no account, quota, branch, or final-pick gate in v6.1.
export default function TrackGate({ children }) { return children; }